<template>
  <div class="main-form">
    <div class="main-form-nav">
      <ul>
        <li @click="itemClick(key)" v-for="(item, key) of props.inspectionData.formDataMain" :class="{ active: activeKey == key, hidden: item.isShow == 0 }" :key="key">
          <span>{{ item.name }}</span>
        </li>
        <li @click="onEmit('gotoPage', 'preview')">
          <span>预览并公示</span>
        </li>
      </ul>
    </div>

    <div class="main-form-content">
      <div class="main-form-content-t">
        <p>
          企业名称：<span>{{ checkRule.companyName }}</span>
        </p>
        <p>
          统一社会信用代码/注册号：<span>{{ checkRule.creditCode }}</span>
        </p>
      </div>

      <div class="main-form-content-b">
        <div class="main-form-content-c">
          <component :is="views" :data="data" :inspectionData="props.inspectionData" @emit="onEmit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { ElMessageBox } from "element-plus";
import { $emit, $on } from "vue-happy-bus";
import base from "./base.vue";
import share from "./share.vue";
import site from "./site.vue";
import change from "./change.vue";
import assert from "./assert.vue";
import party from "./party.vue";
import social from "./social.vue";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,

    default() {
      return {};
    },
  },
});

const checkRule = inject("checkRule");

const itemClick = (key) => {
  if (["license", "invest", "guaranty‌"].includes(key)) {
    // 充装单位许可证 对外投资信息 对外担保信息 不实现
    warn();
    return;
  }

  if (activeKey.value != key) {
    activeKey.value = key;
    views.value = pages[activeKey.value];
  }
};

const pages = {
  base, // 企业基本信息
  share, // 股东及出资信息
  site, // 网站或网店信息
  change, // 股权变更信息
  assert, // 资产状况信息
  party, // 党建信息
  social, // 社保信息
};

const activeKey = ref("base");
const views = shallowRef(pages[activeKey.value]);

const data = computed(() => {
  return props.inspectionData.formDataMain[activeKey.value].data;
});

const onEmit = (type, data) => {
  const inspectionDataClone = cloneDeep(props.inspectionData);

  switch (type) {
    case "isShow":
      const { key, value } = data;
      inspectionDataClone.formDataMain[key].isShow = Math.abs(value - 2);
      $emit("inspectionUpdate", inspectionDataClone);
      break;

    case "submit":
      inspectionDataClone.reportData.lastModifyDate = dayjs().format("YYYY-MM-DD");
      inspectionDataClone.formDataMain[activeKey.value].data = data;
      $emit("inspectionSubmit", inspectionDataClone);
      break;

    case "gotoPage":
      $emit("gotoPage", data);
      break;

    default:
      break;
  }
};

//警告功能
function warn() {
  ElMessageBox.confirm("本系统为教学系统，暂不支持此功能", "信息", {
    showCancelButton: false,
    customStyle: {
      "--el-messagebox-width": "300px",
    },
  }).catch(() => {});
}
</script>

<style lang="scss" scoped>
.main-form {
  flex: 0 0 auto;
  overflow: hidden;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;

  .main-form-nav {
    width: 240px;
    flex: 0 0 auto;
    overflow-y: auto;
    margin-right: 16px;

    ul {
      li {
        display: flex;
        align-items: center;
        height: 48px;
        background: #ab812d;
        box-shadow: 0px -1px 0px #d0ac62 inset;
        padding-left: 22px;
        color: #ffffff;
        font-size: 14px;
        user-select: none;
        cursor: pointer;

        &:hover,
        &.active {
          background-color: #ae1c1c;
        }

        &.active {
          &::before {
            display: inline-block;
            content: "";
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-top-width: 5px;
            border-bottom-width: 5px;
            border-left-color: #ffffff;
            margin-right: 2px;
          }
        }

        &.hidden {
          display: none;
        }
      }
    }
  }

  .main-form-content {
    width: 100%;
    padding: 24px 20px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #d0d0d0;
    border-radius: 2px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .main-form-content-t {
      flex: 0 0 auto;
      overflow: hidden;
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 60px;
      border-bottom: 1px solid #cfa95e;
      cursor: default;

      > p {
        &:not(:nth-last-of-type(1)) {
          margin-right: 20px;
        }

        span {
          font-weight: 700;
        }
      }
    }

    .main-form-content-b {
      margin-top: 20px;
      padding-right: 10px;
      height: 100%;
      overflow: hidden;

      .main-form-content-c {
        height: 100%;

        .formc {
          height: 100%;
          display: flex;
          flex-direction: column;

          :deep() {
            .formc-con {
              height: 100%;
              padding-right: 10px;
              overflow-x: hidden;
              overflow-y: auto;
            }

            .formc-btn {
              flex: 0 0 auto;
              overflow: hidden;
              display: flex;
              justify-content: center;
              margin-top: 10px;

              .el-button {
                color: #ffffff;
                margin: 0 20px;
              }
            }

            .formc-pagination {
              display: flex;
              justify-content: center;

              .el-pagination {
                margin-top: 10px;
                padding: 8px;

                button {
                  border-radius: 0;
                  background-color: #ffffff;
                  border: 1px solid #dadde4;

                  &.btn-prev {
                    margin-right: 0;
                  }

                  &.btn-next {
                    margin-left: 0;
                  }
                }

                .el-pager {
                  li {
                    margin: 0;
                    border-radius: 0;
                  }

                  .is-active {
                    background-color: #cfa95e !important;
                    border-color: #cfa95e !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  :deep(.el-table-s1) {
    width: 100%;
    box-shadow: 0 0 0 0.5px #dfe4ed;

    thead {
      th {
        background-color: #eae3db !important;
        color: #87550f !important;
        border: 0 !important;

        .cell {
          font-weight: bold;
        }
      }
    }
  }

  :deep(.el-table-s2) {
    width: 100%;
    table-layout: fixed;
    overflow: auto;
    border-collapse: collapse;
    border: 1px solid #ebebeb;

    td {
      border: 1px solid #ebebeb;
      vertical-align: middle;

      &.table-label {
        background: #eae3d8;
        color: #ab812d;
        font-weight: 700;
        text-align: center;
      }

      .el-form-item {
        margin: 0;

        .el-input__wrapper,
        .el-select__wrapper {
          box-shadow: none;
        }

        .el-form-item__error {
          width: 100%;
          margin: 0;
          text-align: center;
          padding: 4px;
        }

        .el-date-editor .el-input__icon {
          color: #ff5d5d;
        }
      }
    }
  }

  :deep(.el-table-s3) {
    width: 100%;
    table-layout: fixed;
    overflow: auto;
    border-collapse: collapse;
    border: 1px solid #ebebeb;

    td {
      border: 1px solid #ebebeb;
      vertical-align: middle;

      &.table-label {
        background: #eae3d8;
        color: #ab812d;
        font-weight: 700;
        text-align: right;

        span {
          padding-right: 10px;
          font-weight: 700;
        }
      }

      .td-c1 {
        padding: 5px 0 5px 10px;
        display: flex;

        .el-form-item {
          width: 100%;
        }

        > span {
          flex: 0 0 auto;
          padding: 0 20px;
          color: #999999;
          line-height: 32px;
        }
      }

      .td-c2 {
        display: flex;
        justify-content: center;

        .el-form-item {
          .el-form-item__content {
            align-items: center;
          }
        }
      }

      .el-form-item {
        margin: 0;

        .el-form-item__content {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .el-form-item__error {
          margin: 0;
        }
      }
    }
  }

  :deep(.el-table-s4) {
    width: 100%;
    table-layout: fixed;
    overflow: auto;
    border-collapse: collapse;
    border: 1px solid #ebebeb;

    td {
      border: 1px solid #ebebeb;
      vertical-align: middle;

      &.table-label {
        background: #eae3d8;
        color: #ab812d;
        font-weight: 700;
        text-align: right;

        span {
          padding-right: 10px;
          font-weight: 700;
        }

        p {
          font-weight: 700;
          text-align: center;
        }
      }

      .td-c1 {
        padding: 5px;
      }

      .td-c2 {
        padding: 5px 0 5px 10px;
        display: flex;

        .el-form-item {
          width: 100%;
        }

        > span {
          flex: 0 0 auto;
          padding: 0 20px;
          color: #999999;
          line-height: 32px;
        }
      }

      .el-form-item {
        margin: 0;

        .el-form-item__content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .el-form-item__error {
          margin: 0;
        }
      }
    }
  }

  :deep() {
    .color-999 {
      color: #999999;
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #efefef;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track-piece {
    background: none;
  }
}
</style>
